import { DependencyList, useEffect } from "react";

export function useDebounceEffect(
  fn: () => void,
  waitTime: number,
  deps: DependencyList = [] // Valor padrão para deps
) {
  useEffect(() => {
    const t = setTimeout(() => {
      fn(); // Chama a função diretamente
    }, waitTime);

    return () => {
      clearTimeout(t);
    };
  }, deps); // deps garantidamente será um array
}
